import { authAPI } from "./auth-api";
import { IS_ALFAJR } from '../constants/general';

// API Configuration
export const API_CONFIG = {
  // BASE_URL: 'https://ablemartonline.com/api',
  // BASE_URL: 'https://alpha-temp.ablemartonline.com/api',
  // BASE_URL: 'http://localhost:5001/api',
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://alpha-temp.ablemartonline.com/api',
  ADMIN_BASE_URL: IS_ALFAJR ? 'https://dashboard.fajr.qa' : 'https://admin.ablemartonline.com',
  STAFF_RIDER_BASE_URL: IS_ALFAJR ? 'https://admin.fajr.qa' : 'https://staff.ablemartonline.com',
  // Customer website (Next.js webapp) — used for public pages like admin APK download
  WEB_BASE_URL: (() => {
    if (process.env.REACT_APP_WEB_BASE_URL) return process.env.REACT_APP_WEB_BASE_URL;
    const apiBase = process.env.REACT_APP_API_BASE_URL || '';
    if (/localhost|127\.0\.0\.1/.test(apiBase)) return 'http://localhost:3000';
    return IS_ALFAJR ? 'https://fajr.qa' : 'https://ablemartonline.com';
  })(),
  // Separate base URL for WhatsApp CRM API
  WHATSAPP_CRM_BASE_URL: 'https://crm.ablemartonline.com/api',
  ENDPOINTS: {
    PRODUCTS_LIST: '/v4/admin/product/list',
    PRODUCTS_UPDATE: '/v4/admin/product/update',
    PRODUCTS_ADD: '/v4/admin/product/add',
    PRODUCTS_DELETE: '/v4/admin/product/',
    CATEGORIES_LIST: '/v4/admin/category/fetchAll',
    CATEGORIES_ADD: '/v4/admin/category/add',
    CATEGORIES_UPDATE: '/v4/admin/category/update',
    CATEGORIES_DELETE: '/v4/admin/category/:id',
    CATEGORIES_DELETE_SUBCATEGORY: '/v4/admin/category/:categoryId/subcategory/:subCategoryId',
    CATEGORIES_REORDER: '/v4/admin/category/reorder',
    ADMIN_LOGIN: '/v4/admin/login',
    ADMIN_VERIFY: '/v4/admin/verify',
    ADMIN_CREATE: '/v4/admin/create-admin',
    ADMIN_LIST: '/v4/admin/list',
    ADMIN_UPDATE: '/v4/admin/update',
    ADMIN_DELETE: '/v4/admin',
    ADMIN_SWITCH_STORE: '/v4/admin/switch-store',
    USER_ORDER_REPORT: '/v1/user/admin/user-order-report',
    CREATE_EXCEL_REPORT: '/v1/user/admin/create-excel-report',
    CATEGORY_REPORT: '/v3/admin/product/category-report',
    COUPONS_ADD: '/v4/admin/coupon/add',
    COUPONS_UPDATE: '/v4/admin/coupon/update',
    COUPONS_LIST: '/v4/admin/coupon/list',
    COUPONS_DELETE: '/v4/admin/coupon/delete',
    COUPONS_ANALYTICS: '/v4/admin/coupon/analytics',
    COUPONS_NOTIFICATION_QUE: '/v4/admin/coupon',
    WHATSAPP_QUE_CREATE: '/v4/admin/whatsapp/create-que',
    WHATSAPP_QUE_FETCHALL: '/v4/admin/whatsapp/fetchAll',
    WHATSAPP_QUE_STATS: '/v4/admin/whatsapp/stats',
    WHATSAPP_CHATS: '/v4/admin/whatsapp/chats',
    WHATSAPP_CONVERSATIONS: '/v4/admin/whatsapp/chats/conversations',
    WHATSAPP_CHAT_THREAD: '/v4/admin/whatsapp/chats/thread',
    WHATSAPP_CHAT_SEND: '/v4/admin/whatsapp/chats/send',
    WHATSAPP_CHAT_MARK_READ: '/v4/admin/whatsapp/chats/mark-read',
    STORY_BASE: '/v4/admin/story',
    STORY_CREATE: '/v4/admin/story/create',
    STORY_UPDATE: '/v4/admin/story/update/',
    STORY_ACTIVE: '/v4/admin/story/active',
    STORY_EXPIRED: '/v4/admin/story/expired',
    STORY_REORDER: '/v4/admin/story/reorder',
    BANNER_CREATE: '/v4/admin/banner/create',
    BANNER_UPDATE: '/v4/admin/banner/update',
    BANNER_DELETE: '/v4/admin/banner/',
    BANNER_LIST: '/v4/admin/banner/list',
    BANNER_REORDER: '/v4/admin/banner/reorder',
    BANNER_BULK_UPDATE: '/v4/admin/banner/bulkUpdate',
    NOTIFICATION_QUE_CREATE: '/v4/admin/notification/create-que',
    NOTIFICATION_QUE_FETCHALL: '/v4/admin/notification/fetchAll',
    EVENT_LOGS: '/v4/admin/events/logs',
    SERVER_ERRORS: '/v4/admin/serverError/list',
    CLIENT_ERROR_REPORTS: '/v4/admin/serverError/client-reports/list',
    EVENT_LOG_USERS: '/v4/admin/events/users',
    USER_STATS: '/v4/admin/user/stats',
    USER_DETAILS: '/v4/admin/user/details',
    GENERATE_ADDRESS_EDIT_OTP: '/v4/admin/user/address/generate-otp',
    VERIFY_ADDRESS_EDIT_OTP: '/v4/admin/user/address/verify-otp',
    UPDATE_USER_ADDRESS: '/v4/admin/user/address/update',
    USER_ACTION_LOGS: '/v4/admin/user/actions',
    USER_ANALYTICS: '/v4/admin/analytics/user',
    USER_ACTION_LOGS_COUNT: '/v4/admin/analytics/action-logs',
    HOURLY_SUMMARY: '/v4/admin/analytics/hourly-summary',
    ORDERS_LIST: '/v4/admin/order/list',
    ORDER_DETAILS: '/v4/admin/order/details',
    ORDER_ADD_PRODUCT: '/v4/admin/order/add-product',
    ORDER_EDIT_ITEM: '/v4/admin/order/edit-item',
    ORDER_FILTER_OPTIONS: '/v4/admin/order/filter',
    ADMIN_POLLING: '/v4/admin/order/poll',
    ORDER_CANCEL_ACTION: '/v4/admin/order/cancel-action',
    ORDER_ASSIGN_STAFF: '/v4/admin/order/assign-staff',
    ORDER_UPDATE_STATUS: '/v4/admin/order/update-status',
    ORDER_UPDATE_ADDRESS: '/v4/admin/order/update-address',
    CUSTOM_ORDER_CREATE: '/v4/admin/custom-order',
    CUSTOM_ORDER_DETAIL: '/v4/admin/custom-order',
    CONFIG_TIMESLOTS: '/v1/config/timeslot',
    GENERAL_SUBCATEGORIES_LIST: '/v4/admin/category/list-general',
    GENERAL_SUBCATEGORIES_ADD: '/v4/admin/category/add-general',
    GENERAL_CONFIG_LIST: '/v4/admin/generalConfig/list',
    GENERAL_CONFIG_EXPRESS: '/v4/admin/generalConfig/express',
    GENERAL_CONFIG_CHAT: '/v4/admin/generalConfig/chat',
    GENERAL_CONFIG_ADMIN_APP: '/v4/admin/generalConfig/admin-app',
    GENERAL_CONFIG_UPDATE: '/v4/admin/generalConfig/update-settings',
    CONFIG_TIME_SLOT_UPDATE: '/v4/admin/generalConfig/time-slots',
    GENERAL_CONFIG_SPIN_WHEEL: '/v4/admin/generalConfig/spin-wheel',
    GENERAL_CONFIG_CLEAR_CACHE: '/v4/admin/generalConfig/redis-cache',
    SPIN_WHEEL_STATS: '/v4/admin/spin-wheel/stats',
    SPIN_WHEEL_WINNERS_HISTORY: '/v4/admin/spin-wheel/winners-history',
    REEL_VIDEO_CREATE: '/v4/admin/reelVideo/create',
    REEL_VIDEO_ACTIVE: '/v4/admin/reelVideo/active',
    REEL_VIDEO_INACTIVE: '/v4/admin/reelVideo/inactive',
    REEL_VIDEO_UPDATE: '/v4/admin/reelVideo/update',
    REEL_VIDEO_REORDER: '/v4/admin/reelVideo/reorder',
    REEL_VIDEO_DELETE: '/v4/admin/reelVideo',
    CRM_SUMMARY: '/v4/admin/crm/summary',
    ORDER_LIST_CONFIRMED: '/v4/admin/order/confirmed',
    DRIVERS_LIST: '/v4/admin/driver/fetch',
    DRIVERS_REQUEST_LOCATION: '/v4/admin/driver/request-location',
    DRIVERS_ADD: '/v4/admin/driver/add',
    DRIVERS_UPDATE: '/v4/admin/driver/update',
    DRIVERS_DELETE: '/v4/admin/driver/delete',
    DISPATCH_PLAN_ROUTES: '/v4/admin/dispatch/plan',
    ROUTE_HISTORY: '/v4/admin/dispatch/route-history',
    DISPATCH_FETCH: '/v4/admin/dispatch/fetch',
    ROUTE_OVERVIEW: '/v4/admin/dispatch/route-overview',
    DISPATCH_HISTORY: '/v4/admin/dispatch/history',
    DISPATCH_HISTORY_SLOTS: '/v4/admin/dispatch/history/slots',
    USER_COIN_HISTORY: '/v4/admin/user/coin-history',
    USER_WALLET_HISTORY: '/v4/admin/user/wallet-history',
    USER_COUPONS: '/v4/admin/user/coupons',
    CHATS_LIST: '/v4/admin/chat',
    CHAT_DETAIL: '/v4/admin/chat/detail',
    CHAT_UPDATE_STATUS: '/v4/admin/chat/update-status',
    CHAT_SEND_MESSAGE: '/v4/admin/chat/send-message',
    ADMIN_TRANSLATE: '/v4/admin/translate',
    SEO_LIST: '/v4/admin/seo/list',
    SEO_PRODUCT: '/v4/admin/seo/product',
    SEO_SAVE: '/v4/admin/seo/save',
    SEO_CATEGORY_LIST: '/v4/admin/seo/category/list',
    SEO_CATEGORY: '/v4/admin/seo/category',
    SEO_CATEGORY_SAVE: '/v4/admin/seo/category/save',
    SEO_SITEMAP: '/v4/admin/product/sitemap',
    MONITORING_LOGS: '/monitoring/logs',
  }
};

// Default payload for products list
export const DEFAULT_PRODUCTS_PAYLOAD = {
  page: 1,
  searchQuery: "",
  isAdmin: true,
  isAvailable: ""
};

const getAuthHeaders = () => {
  const token = authAPI.getToken();
  const headers = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};

const getAuthNoHeaders = () => {
  const token = authAPI.getToken();
  const headers = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

// Helper function to build full API URL
export const buildApiUrl = (endpoint) => {
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) {
    return endpoint;
  }
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to build WhatsApp CRM API URL
export const buildWhatsappCrmApiUrl = (endpoint) => {
  return `${API_CONFIG.WHATSAPP_CRM_BASE_URL}${endpoint}`;
};

// Helper function to make API calls
export const apiCall = async (endpoint, options = {}) => {
  const url = buildApiUrl(endpoint);
  const isFormDataRequest = options.body instanceof FormData;
  const defaultOptions = {
    method: 'GET',
    headers: isFormDataRequest ? getAuthNoHeaders() : getAuthHeaders(),
  };

  const finalOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...(options.headers || {}),
    }
  };

  try {
    const response = await fetch(url, finalOptions);

    if (response.status === 401) {
      authAPI.handleSessionExpired();
      return { success: false, error: 'Unauthorized', message: 'Session expired' };
    }

    const rawText = await response.text();
    let data = {};
    try {
      data = rawText ? JSON.parse(rawText) : {};
    } catch (parseError) {
      data = {
        success: false,
        msg: rawText || `Request failed (${response.status})`,
      };
    }

    if (!response.ok) {
      return {
        success: false,
        ...data,
        msg: data.msg || data.error || `Request failed (${response.status})`,
      };
    }

    return data;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};
